// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"jxfoI":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalCardViewContext", ()=>InternalCardViewContext);
parcelHelpers.export(exports, "CardContext", ()=>CardContext);
parcelHelpers.export(exports, "Card", ()=>Card);
parcelHelpers.export(exports, "CardPreview", ()=>CardPreview);
parcelHelpers.export(exports, "CollectionCardPreview", ()=>CollectionCardPreview);
parcelHelpers.export(exports, "AssetCard", ()=>AssetCard);
parcelHelpers.export(exports, "UserCard", ()=>UserCard);
parcelHelpers.export(exports, "ProductCard", ()=>ProductCard);
var _jsxRuntime = require("react/jsx-runtime");
var _actionMenu = require("./ActionMenu");
var _avatar = require("./Avatar");
var _button = require("./Button");
var _checkbox = require("./Checkbox");
var _composeRenderProps = require("react-aria-components/composeRenderProps");
var _content = require("./Content");
var _slots = require("react-aria-components/slots");
var _react = require("react");
var _divider = require("./Divider");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _icon = require("./Icon");
var _image = require("./Image");
var _imageCoordinator = require("./ImageCoordinator");
var _inertValue = require("react-aria/private/utils/inertValue");
var _link = require("react-aria-components/Link");
var _runtime = require("../style/runtime");
var _pressScale = require("./pressScale");
var _skeleton = require("./Skeleton");
var _useDOMRef = require("./useDOMRef");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const borderRadius = {
    default: 'lg',
    size: {
        XS: 'default',
        S: 'default'
    }
};
let card = function anonymous(props, overrides) {
    let rules = " ";
    let position = false;
    let width = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "_P") position = true;
        if (p[1] === "Z") width = true;
        rules += p[0];
    }
    rules += ' sd13';
    rules += ' _ta13';
    if (!position) rules += ' _Pc13';
    if (props.size === "S") rules += ' oH5kTnc13';
    else if (props.size === "XS") rules += ' oH5kTnc13';
    else rules += ' o5NLVAe13';
    if (props.size === "S") rules += ' nH5kTnc13';
    else if (props.size === "XS") rules += ' nH5kTnc13';
    else rules += ' n5NLVAe13';
    if (props.size === "S") rules += ' kH5kTnc13';
    else if (props.size === "XS") rules += ' kH5kTnc13';
    else rules += ' k5NLVAe13';
    if (props.size === "S") rules += ' jH5kTnc13';
    else if (props.size === "XS") rules += ' jH5kTnc13';
    else rules += ' j5NLVAe13';
    if (props.variant === "secondary") rules += ' -Ovbhqd-gqlRAZb13';
    else if (props.variant === "primary") rules += ' -Ovbhqd-g_g13';
    rules += ' -Ovbhqd-lOVIhfcg8qxrJ13';
    rules += ' -Ovbhqd-lOVIhfcg8qxrJ13';
    if (props.variant === "quiet") rules += ' g913';
    else if (props.variant === "tertiary") rules += ' g913';
    else rules += ' gEzkoQe13';
    if (props.variant === "quiet") rules += ' _nd13';
    else if (props.variant === "tertiary") {
        if (props.isSelected) rules += ' _nd13';
        else if (props.isFocusVisible) rules += ' _nrC99Ne13';
        else if (props.isHovered) rules += ' _nrC99Ne13';
        else rules += ' _nnvmtGb13';
        rules += ' _nlOVIhfci6j2Ec13';
        rules += ' _nlOVIhfci6j2Ec13';
    } else {
        if (props.isSelected) rules += ' _nLeasBb13';
        else if (props.isFocusVisible) rules += ' _nLeasBb13';
        else if (props.isHovered) rules += ' _nLeasBb13';
        else rules += ' _n4zCLMe13';
        rules += ' _nlOVIhfcJWldjc13';
        rules += ' _nlOVIhfcJWldjc13';
    }
    rules += ' _yb13';
    rules += ' Yd13';
    rules += ' Xb13';
    rules += ' _2b13';
    rules += ' uk13';
    rules += ' ucJ9TBTb13';
    rules += ' ud3Euai13';
    rules += ' uea13';
    rules += ' ugb13';
    rules += ' uhd13';
    rules += ' uje13';
    rules += ' u2NhKxcl13';
    rules += ' uic13';
    rules += ' _Xa13';
    if (props.variant === "quiet") rules += ' _Ne13';
    else rules += ' _Nb13';
    if (props.variant === "quiet") rules += ' Pe13';
    else rules += ' Pb13';
    rules += ' _qc13';
    rules += ' __ca13';
    if (props.isCardView) rules += ' _4c13';
    if (props.isLink) rules += ' ry13';
    if (props.isCardView) {
        if (!width) rules += ' Za13';
    } else if (props.size === "XL") {
        if (!width) rules += ' ZhAHjGc13';
    } else if (props.size === "L") {
        if (!width) rules += ' ZCRH0Cc13';
    } else if (props.size === "M") {
        if (!width) rules += ' ZIqJukc13';
    } else if (props.size === "S") {
        if (!width) rules += ' Z7AJvic13';
    } else if (props.size === "XS") {
        if (!width) rules += ' ZJWXjic13';
    }
    rules += ' Fb13';
    if (props.density === "spacious") {
        if (props.size === "XL") rules += ' -dAV6Jb-Ti13';
        else if (props.size === "L") rules += ' -dAV6Jb-Th13';
        else if (props.size === "M") rules += ' -dAV6Jb-Tg13';
        else if (props.size === "S") rules += ' -dAV6Jb-Tf13';
        else if (props.size === "XS") rules += ' -dAV6Jb-Te13';
    } else if (props.density === "regular") {
        if (props.size === "XL") rules += ' -dAV6Jb-Th13';
        else if (props.size === "L") rules += ' -dAV6Jb-Tg13';
        else if (props.size === "M") rules += ' -dAV6Jb-Tf13';
        else if (props.size === "S") rules += ' -dAV6Jb-Te13';
        else if (props.size === "XS") rules += ' -dAV6Jb-Tt13';
    } else if (props.density === "compact") {
        if (props.size === "XL") rules += ' -dAV6Jb-Tg13';
        else if (props.size === "L") rules += ' -dAV6Jb-Tf13';
        else if (props.size === "M") rules += ' -dAV6Jb-Te13';
        else if (props.size === "S") rules += ' -dAV6Jb-Tt13';
        else if (props.size === "XS") rules += ' -dAV6Jb-T1DOfn13';
    }
    if (props.variant === "quiet") rules += ' -jXLvjd-Td13';
    else rules += ' -jXLvjd-T5gMYHd13';
    if (props.variant === "quiet") rules += ' -iXLvjd-Sd13';
    else rules += ' -iXLvjd-S5gMYHd13';
    rules += ' TxTaQHd13';
    rules += ' QxTaQHd13';
    rules += ' S0SaQHd13';
    rules += ' R0SaQHd13';
    rules += ' _oa13';
    if (props.variant === "quiet") rules += ' _Le13';
    else if (props.isFocusVisible) rules += ' _Lf13';
    else rules += ' _Le13';
    rules += ' Oh13';
    rules += ' OlOVIhfcebS7sd13';
    rules += ' OlOVIhfcebS7sd13';
    rules += ' _Mc13';
    rules += ' _Kd13';
    return rules;
};
let selectionIndicator = function anonymous(props) {
    let rules = " ";
    rules += ' _Pa13';
    rules += ' Wr13';
    rules += ' _lr13';
    rules += ' _Ar13';
    rules += ' _zr13';
    rules += ' _9d13';
    if (props.size === "S") rules += ' oH5kTnc13';
    else if (props.size === "XS") rules += ' oH5kTnc13';
    else rules += ' o5NLVAe13';
    if (props.size === "S") rules += ' nH5kTnc13';
    else if (props.size === "XS") rules += ' nH5kTnc13';
    else rules += ' n5NLVAe13';
    if (props.size === "S") rules += ' kH5kTnc13';
    else if (props.size === "XS") rules += ' kH5kTnc13';
    else rules += ' k5NLVAe13';
    if (props.size === "S") rules += ' jH5kTnc13';
    else if (props.size === "XS") rules += ' jH5kTnc13';
    else rules += ' j5NLVAe13';
    rules += ' _Ob13';
    rules += ' _kc13';
    rules += ' hc13';
    rules += ' mc13';
    rules += ' lc13';
    rules += ' _jf13';
    rules += ' ik13';
    rules += ' Yd13';
    rules += ' Xb13';
    rules += ' _2b13';
    if (props.isSelected) rules += ' _Ib13';
    else rules += ' _Ia13';
    rules += ' OGcUfH13';
    rules += ' _Kc13';
    if (props.isStrokeInner) rules += ' _Lf13';
    else rules += ' _Le13';
    rules += ' _Mc13';
    return rules;
};
let preview = function anonymous(props) {
    let rules = " ";
    rules += ' _Pc13';
    rules += ' Yd13';
    rules += ' Xb13';
    rules += ' _2b13';
    rules += ' _Nb13';
    rules += ' Pb13';
    rules += ' I8cyuNb13';
    rules += ' H8cyuNb13';
    rules += ' J39J4qb13';
    rules += ' Gk39J4qb13';
    if (props.isQuiet) {
        if (props.size === "S") rules += ' oH5kTnc13';
        else if (props.size === "XS") rules += ' oH5kTnc13';
        else rules += ' o5NLVAe13';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' nH5kTnc13';
        else if (props.size === "XS") rules += ' nH5kTnc13';
        else rules += ' n5NLVAe13';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' kH5kTnc13';
        else if (props.size === "XS") rules += ' kH5kTnc13';
        else rules += ' k5NLVAe13';
    }
    if (props.isQuiet) {
        if (props.size === "S") rules += ' jH5kTnc13';
        else if (props.size === "XS") rules += ' jH5kTnc13';
        else rules += ' j5NLVAe13';
    }
    if (props.isQuiet) {
        if (props.isSelected) rules += ' _nLeasBb13';
        else if (props.isFocusVisible) rules += ' _nLeasBb13';
        else if (props.isHovered) rules += ' _nLeasBb13';
    }
    if (props.isQuiet) {
        if (props.isFocusVisible) rules += ' _Lf13';
    } else rules += ' _Le13';
    rules += ' Oh13';
    rules += ' OlOVIhfcebS7sd13';
    rules += ' OlOVIhfcebS7sd13';
    rules += ' _Mc13';
    rules += ' _Kd13';
    return rules;
};
const image = function anonymous(props) {
    let rules = " ";
    rules += ' Za13';
    if (props.layout === "grid") rules += ' fc13';
    rules += ' _Hb13';
    rules += ' _4c13';
    rules += ' _Ob13';
    return rules;
};
let title = function anonymous(props) {
    let rules = " ";
    rules += ' uk13';
    rules += ' ucJ9TBTb13';
    rules += ' ud3Euai13';
    rules += ' uea13';
    rules += ' ugb13';
    rules += ' uhd13';
    rules += ' uje13';
    rules += ' u2NhKxcl13';
    rules += ' uic13';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-c13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-b13';
        rules += ' vFHT6Dd13';
    }
    rules += ' xd13';
    rules += ' _xa13';
    rules += ' xX0cczbc13';
    rules += ' _xX0cczba13';
    rules += ' xfd13';
    rules += ' _xfa13';
    rules += ' xfX0cczbc13';
    rules += ' _xfX0cczba13';
    rules += ' _Fd13';
    rules += ' _FnuYUweb13';
    rules += ' po13';
    rules += ' __Ea13';
    rules += ' sa13';
    rules += ' __aa13';
    rules += ' __ba13';
    rules += ' zn9DOs13';
    rules += ' yn9DOs13';
    rules += ' Bn9DOs13';
    rules += ' An9DOs13';
    return rules;
};
let description = function anonymous(props) {
    let rules = " ";
    rules += ' uk13';
    rules += ' ucJ9TBTb13';
    rules += ' ud3Euai13';
    rules += ' uea13';
    rules += ' ugb13';
    rules += ' uhd13';
    rules += ' uje13';
    rules += ' u2NhKxcl13';
    rules += ' uic13';
    if (props.size === "XL") {
        rules += ' -_6BNtrc-d13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-c13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "M") {
        rules += ' -_6BNtrc-b13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-a13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a13';
        rules += ' vFHT6Dd13';
    }
    rules += ' xb13';
    rules += ' _xa13';
    rules += ' _Fb13';
    rules += ' _FnuYUwec13';
    rules += ' pt13';
    rules += ' __Ea13';
    rules += ' sa13';
    rules += ' __aa13';
    rules += ' __ba13';
    rules += ' z9u7zPc13';
    rules += ' y9u7zPc13';
    rules += ' B9u7zPc13';
    rules += ' A9u7zPc13';
    return rules;
};
let content = function anonymous(props) {
    let rules = " ";
    rules += ' se13';
    rules += ' DM8Mfn13';
    rules += ' DlsIuJI4ff413';
    rules += ' CfLapxc13';
    rules += ' ClsIuJg9IhLd13';
    rules += ' qR3ltQc13';
    rules += ' _ub13';
    rules += ' ea13';
    rules += ' _cf13';
    if (props.size === "XL") rules += ' UH5kTnc13';
    else if (props.size === "L") rules += ' UbCyY5d13';
    else if (props.size === "M") rules += ' UbCyY5d13';
    else if (props.size === "S") rules += ' UR3ltQc13';
    else if (props.size === "XS") rules += ' UR3ltQc13';
    rules += ' T5gMYHd13';
    rules += ' Tbd13';
    rules += ' Q69YG2b13';
    rules += ' Qkd13';
    return rules;
};
let actionMenu = " zgSHDrc13 ygSHDrc13 BgSHDrc13 AgSHDrc13 JTnYEIe13 GTnYEIe13";
let footer = " sd13 _tc13 ec13 _Ce13 UH5kTnc13 qH5kTnc13 T69YG2b13";
const InternalCardViewContext = /*#__PURE__*/ (0, _react.createContext)({
    ElementType: 'div',
    layout: 'grid'
});
const CardContext = /*#__PURE__*/ (0, _react.createContext)(null);
const InternalCardContext = /*#__PURE__*/ (0, _react.createContext)({
    isQuiet: false,
    size: 'M',
    isSelected: false,
    isHovered: false,
    isFocusVisible: false,
    isPressed: false,
    isCheckboxSelection: true
});
const actionButtonSize = {
    XS: 'XS',
    S: 'XS',
    M: 'S',
    L: 'M',
    XL: 'L'
};
const Card = /*#__PURE__*/ (0, _react.forwardRef)(function Card(props, ref) {
    [props] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, CardContext);
    let { ElementType, layout } = (0, _react.useContext)(InternalCardViewContext);
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let { density = 'regular', size = 'M', variant = 'primary', UNSAFE_className = '', UNSAFE_style, styles, id, ...otherProps } = props;
    let isQuiet = variant === 'quiet';
    let isSkeleton = (0, _skeleton.useIsSkeleton)();
    let children = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
        values: [
            [
                (0, _image.ImageContext),
                {
                    alt: '',
                    styles: image({
                        layout
                    })
                }
            ],
            [
                (0, _content.TextContext),
                {
                    slots: {
                        [(0, _slots.DEFAULT_SLOT)]: {},
                        title: {
                            styles: title({
                                size
                            })
                        },
                        description: {
                            styles: description({
                                size
                            })
                        }
                    }
                }
            ],
            [
                (0, _content.ContentContext),
                {
                    styles: content({
                        size
                    })
                }
            ],
            [
                (0, _divider.DividerContext),
                {
                    size: 'S'
                }
            ],
            [
                (0, _content.FooterContext),
                {
                    styles: footer
                }
            ],
            [
                (0, _actionMenu.ActionMenuContext),
                {
                    isQuiet: true,
                    size: actionButtonSize[size],
                    isDisabled: isSkeleton,
                    // @ts-ignore
                    'data-slot': 'menu',
                    styles: actionMenu
                }
            ],
            [
                (0, _skeleton.SkeletonContext),
                isSkeleton
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageCoordinator.ImageCoordinator), {
            children: typeof props.children === 'function' ? props.children({
                size
            }) : props.children
        })
    });
    let press = (0, _pressScale.pressScale)(domRef, UNSAFE_style);
    if (ElementType === 'div' && !isSkeleton && props.href) // Standalone Card that has an href should be rendered as a Link.
    // NOTE: In this case, the card must not contain interactive elements.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        ...(0, _filterDOMProps.filterDOMProps)(otherProps, {
            isLink: true
        }),
        ref: domRef,
        className: (renderProps)=>UNSAFE_className + card({
                ...renderProps,
                size,
                density,
                variant,
                isCardView: false,
                isLink: true
            }, styles),
        style: (renderProps)=>// Only the preview in quiet cards scales down on press
            variant === 'quiet' ? UNSAFE_style : press(renderProps),
        children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalCardContext.Provider, {
                value: {
                    size,
                    isQuiet,
                    isCheckboxSelection: false,
                    isSelected: false,
                    ...renderProps
                },
                children: children
            })
    });
    if (ElementType === 'div' || isSkeleton) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...(0, _filterDOMProps.filterDOMProps)(otherProps),
        id: id != null ? String(id) : undefined,
        // @ts-ignore - React < 19 compat
        inert: (0, _inertValue.inertValue)(isSkeleton),
        ref: domRef,
        className: UNSAFE_className + card({
            size,
            density,
            variant,
            isCardView: ElementType !== 'div'
        }, styles),
        style: UNSAFE_style,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InternalCardContext.Provider, {
            value: {
                size,
                isQuiet,
                isCheckboxSelection: false,
                isHovered: false,
                isFocusVisible: false,
                isSelected: false,
                isPressed: false
            },
            children: children
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ElementType, {
        ...props,
        ref: domRef,
        className: (renderProps)=>UNSAFE_className + card({
                ...renderProps,
                isCardView: true,
                isLink: !!props.href,
                size,
                density,
                variant
            }, styles),
        style: (renderProps)=>// Only the preview in quiet cards scales down on press
            variant === 'quiet' ? UNSAFE_style : press(renderProps),
        children: ({ selectionMode, selectionBehavior, isHovered, isFocusVisible, isSelected, isPressed })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(InternalCardContext.Provider, {
                value: {
                    size,
                    isQuiet,
                    isCheckboxSelection: selectionMode !== 'none' && selectionBehavior === 'toggle',
                    isHovered,
                    isFocusVisible,
                    isSelected,
                    isPressed
                },
                children: [
                    !isQuiet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectionIndicator, {}),
                    !isQuiet && selectionMode !== 'none' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardCheckbox, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: " sc13",
                        children: children
                    })
                ]
            })
    });
});
function SelectionIndicator() {
    let { size, isSelected, isQuiet, isCheckboxSelection } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: selectionIndicator({
            size,
            isSelected,
            // Add an inner stroke only for quiet cards with no checkbox to
            // help distinguish the selected state from the preview.
            isStrokeInner: isQuiet && !isCheckboxSelection
        })
    });
}
function CardCheckbox() {
    let { size } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: " _Pa13 W5gMYHd13 _A5gMYHd13 _9d13 Tp13 Qp13 Sp13 Rp13 gGcUfH13 oH5kTnc13 nH5kTnc13 kH5kTnc13 jH5kTnc13 _n4zCLMe13",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
            slot: "selection",
            excludeFromTabOrder: true,
            size: size === 'XS' ? 'S' : size
        })
    });
}
const CardPreview = /*#__PURE__*/ (0, _react.forwardRef)(function CardPreview(props, ref) {
    let { size, isQuiet, isHovered, isFocusVisible, isSelected, isPressed, isCheckboxSelection } = (0, _react.useContext)(InternalCardContext);
    let { UNSAFE_className = '', UNSAFE_style } = props;
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...(0, _filterDOMProps.filterDOMProps)(props),
        slot: "preview",
        ref: domRef,
        className: UNSAFE_className + preview({
            size,
            isQuiet,
            isHovered,
            isFocusVisible,
            isSelected
        }),
        style: isQuiet ? (0, _pressScale.pressScale)(domRef)({
            isPressed
        }) : UNSAFE_style,
        children: [
            isQuiet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectionIndicator, {}),
            isQuiet && isCheckboxSelection && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardCheckbox, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: " oi13 ni13 ki13 ji13 _Nb13 Pb13",
                children: props.children
            })
        ]
    });
});
const collection = function anonymous(props) {
    let rules = " ";
    rules += ' se13';
    rules += ' DvhgoHd13';
    if (props.size === "S") rules += ' Uahikk13';
    else if (props.size === "XS") rules += ' Uahikk13';
    else rules += ' UR3ltQc13';
    if (props.size === "S") rules += ' qahikk13';
    else if (props.size === "XS") rules += ' qahikk13';
    else rules += ' qR3ltQc13';
    return rules;
};
const collectionImage = " Za13 fa13 f5DbKFc13 y5DbKFwoofG13 _Hb13 _Ob13 _4c13";
const CollectionCardPreview = /*#__PURE__*/ (0, _react.forwardRef)(function CollectionCardPreview(props, ref) {
    let { size } = (0, _react.useContext)(InternalCardContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardPreview, {
        ...props,
        ref: ref,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: collection({
                size
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _image.ImageContext).Provider, {
                value: {
                    styles: collectionImage
                },
                children: props.children
            })
        })
    });
});
const AssetCard = /*#__PURE__*/ (0, _react.forwardRef)(function AssetCard(props1, ref) {
    let { layout } = (0, _react.useContext)(InternalCardViewContext);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props1,
        ref: ref,
        density: "regular",
        children: (0, _composeRenderProps.composeRenderProps)(props1.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            alt: '',
                            styles: function anonymous(props) {
                                let rules = " ";
                                rules += ' Za13';
                                if (props.layout === "grid") rules += ' fa13';
                                rules += ' _Ha13';
                                rules += ' _Ob13';
                                rules += ' _4c13';
                                return rules;
                            }({
                                layout
                            })
                        }
                    ],
                    [
                        (0, _icon.IllustrationContext),
                        {
                            render (icon) {
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: " sd13 eb13 _Ca13 gH13 fa13",
                                        children: icon
                                    })
                                });
                            },
                            styles: " Fd13 L3HJbhc13 K3HJbhc13 Zc13"
                        }
                    ]
                ],
                children: children
            }))
    });
});
const avatarSize = {
    XS: 24,
    S: 48,
    M: 64,
    L: 64,
    XL: 80
};
const UserCard = /*#__PURE__*/ (0, _react.forwardRef)(function UserCard(props, ref) {
    let { size = 'M' } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props,
        ref: ref,
        density: "spacious",
        children: (0, _composeRenderProps.composeRenderProps)(props.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            alt: '',
                            styles: " Za13 fb13 _Hb13 _Ob13 _4c13"
                        }
                    ],
                    [
                        (0, _avatar.AvatarContext),
                        {
                            size: avatarSize[size],
                            UNSAFE_style: {
                                '--size': avatarSize[size] / 16 + 'rem'
                            },
                            styles: " _Pc13 JYB8I13 Jkymupd0fnV8d13",
                            isOverBackground: true
                        }
                    ]
                ],
                children: children
            }))
    });
});
const buttonSize = {
    XS: 'S',
    S: 'S',
    M: 'M',
    L: 'L',
    XL: 'XL'
};
const ProductCard = /*#__PURE__*/ (0, _react.forwardRef)(function ProductCard(props1, ref) {
    let { size = 'M' } = props1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Card, {
        ...props1,
        ref: ref,
        density: "spacious",
        children: (0, _composeRenderProps.composeRenderProps)(props1.children, (children)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
                values: [
                    [
                        (0, _image.ImageContext),
                        {
                            slots: {
                                preview: {
                                    alt: '',
                                    styles: " Za13 fd13 _Hb13 _Ob13 _4c13"
                                },
                                thumbnail: {
                                    alt: '',
                                    styles: function anonymous(props) {
                                        let rules = " ";
                                        rules += ' _Pc13';
                                        rules += ' _Ob13';
                                        rules += ' _4c13';
                                        if (props.size === "XL") rules += ' ZyrQkVc13';
                                        else if (props.size === "L") rules += ' ZA3MuBd13';
                                        else if (props.size === "M") rules += ' Z3JjxG13';
                                        else if (props.size === "S") rules += ' ZLhWnQb13';
                                        else if (props.size === "XS") rules += ' ZCe2o8c13';
                                        rules += ' FRuFGYc13';
                                        if (props.size === "S") rules += ' oR3ltQc13';
                                        else if (props.size === "XS") rules += ' oR3ltQc13';
                                        else rules += ' oH5kTnc13';
                                        if (props.size === "S") rules += ' nR3ltQc13';
                                        else if (props.size === "XS") rules += ' nR3ltQc13';
                                        else rules += ' nH5kTnc13';
                                        if (props.size === "S") rules += ' kR3ltQc13';
                                        else if (props.size === "XS") rules += ' kR3ltQc13';
                                        else rules += ' kH5kTnc13';
                                        if (props.size === "S") rules += ' jR3ltQc13';
                                        else if (props.size === "XS") rules += ' jR3ltQc13';
                                        else rules += ' jH5kTnc13';
                                        rules += ' _Hb13';
                                        rules += ' JYB8I13';
                                        rules += ' JkymupdLu7Bcc13';
                                        rules += ' _Lf13';
                                        if (props.size === "XS") rules += ' _Mb13';
                                        else rules += ' _Mc13';
                                        rules += ' OEzkoQe13';
                                        if (props.size === "XL") rules += ' -F_-FyrQkVc13';
                                        else if (props.size === "L") rules += ' -F_-FA3MuBd13';
                                        else if (props.size === "M") rules += ' -F_-F3JjxG13';
                                        else if (props.size === "S") rules += ' -F_-FLhWnQb13';
                                        else if (props.size === "XS") rules += ' -F_-FCe2o8c13';
                                        return rules;
                                    }({
                                        size
                                    })
                                }
                            }
                        }
                    ],
                    [
                        (0, _content.FooterContext),
                        {
                            styles: (0, _runtime.mergeStyles)(footer, " _Cb13")
                        }
                    ],
                    [
                        (0, _button.ButtonContext),
                        {
                            size: buttonSize[size]
                        }
                    ],
                    [
                        (0, _button.LinkButtonContext),
                        {
                            size: buttonSize[size]
                        }
                    ]
                ],
                children: children
            }))
    });
});

},{"0":"1aScm","1":"djnhn","2":"9JVds","3":"k13eK","4":"29keh","5":"8UvLf","6":"kf2At","7":"l7rkT","8":"km8Hh","9":"659Zi","10":"lPr3p","11":"5WSnw","12":"ijKky","13":"PONm7","14":"jyVFO","15":"alaq0","16":"8VyXK","17":"8qJIV","18":"cGMB8","19":"kPtpC","20":"cKCLH","21":"eqAcu","react/jsx-runtime":"2Is6Z","./ActionMenu":"3fSPo","./Avatar":"f3T9F","./Button":"gZHck","./Checkbox":"jdSVu","react-aria-components/composeRenderProps":"bA6Cz","./Content":"10r6w","react-aria-components/slots":"bA6Cz","react":"a1TxN","./Divider":"kGk2u","react-aria/filterDOMProps":"c0Owd","./Icon":"jQAJE","./Image":"4LTiE","./ImageCoordinator":"3PQZz","react-aria/private/utils/inertValue":"8at61","react-aria-components/Link":"fOCdV","../style/runtime":"8g9no","./pressScale":"8Ufux","./Skeleton":"1mUnF","./useDOMRef":"9tqah","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1aScm":[function() {},{}],"djnhn":[function() {},{}],"9JVds":[function() {},{}],"k13eK":[function() {},{}],"29keh":[function() {},{}],"8UvLf":[function() {},{}],"kf2At":[function() {},{}],"l7rkT":[function() {},{}],"km8Hh":[function() {},{}],"659Zi":[function() {},{}],"lPr3p":[function() {},{}],"5WSnw":[function() {},{}],"ijKky":[function() {},{}],"PONm7":[function() {},{}],"jyVFO":[function() {},{}],"alaq0":[function() {},{}],"8VyXK":[function() {},{}],"8qJIV":[function() {},{}],"cGMB8":[function() {},{}],"kPtpC":[function() {},{}],"cKCLH":[function() {},{}],"eqAcu":[function() {},{}],"3fSPo":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionMenuContext", ()=>ActionMenuContext);
parcelHelpers.export(exports, "ActionMenu", ()=>ActionMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _actionButton = require("./ActionButton");
var _react = require("react");
var _filterDOMProps = require("react-aria/filterDOMProps");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _menu = require("./Menu");
var _s2IconMore20NSvg = require("../s2wf-icons/S2_Icon_More_20_N.svg");
var _s2IconMore20NSvgDefault = parcelHelpers.interopDefault(_s2IconMore20NSvg);
var _useLocalizedStringFormatter = require("react-aria/useLocalizedStringFormatter");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const ActionMenuContext = /*#__PURE__*/ (0, _react.createContext)(null);
const ActionMenu = /*#__PURE__*/ (0, _react.forwardRef)(function ActionMenu(props, ref) {
    let stringFormatter = (0, _useLocalizedStringFormatter.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-spectrum/s2');
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, ActionMenuContext);
    let buttonProps = (0, _filterDOMProps.filterDOMProps)(props, {
        labelable: true
    });
    if (buttonProps['aria-label'] === undefined) buttonProps['aria-label'] = stringFormatter.format('menu.moreActions');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menu.MenuTrigger), {
        isOpen: props.isOpen,
        defaultOpen: props.defaultOpen,
        onOpenChange: props.onOpenChange,
        align: props.align,
        direction: props.direction,
        shouldFlip: props.shouldFlip,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionButton.ActionButton), {
                ref: ref,
                size: props.size,
                isDisabled: props.isDisabled,
                autoFocus: props.autoFocus,
                isQuiet: props.isQuiet,
                styles: props.styles,
                ...buttonProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _s2IconMore20NSvgDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
                items: props.items,
                disabledKeys: props.disabledKeys,
                onAction: props.onAction,
                size: props.menuSize,
                shouldCloseOnSelect: props.shouldCloseOnSelect,
                children: props.children
            })
        ]
    });
});

},{"react/jsx-runtime":"2Is6Z","./ActionButton":"lNDRs","react":"a1TxN","react-aria/filterDOMProps":"c0Owd","../intl/*.json":"gDH3q","./Menu":"1F0Yz","../s2wf-icons/S2_Icon_More_20_N.svg":"gP3id","react-aria/useLocalizedStringFormatter":"4LM0k","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hYP4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAB_DEFS", ()=>TAB_DEFS);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _reactAriaLogo = require("./icons/ReactAriaLogo");
const TAB_DEFS = {
    'react-spectrum': {
        label: 'React Spectrum',
        description: "Components for Adobe's Spectrum design system",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {})
    },
    'react-aria': {
        label: 'React Aria',
        description: 'Style-free components and hooks for building accessible UIs',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {})
    }
};

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=Autocomplete.9ac4fa77.js.map
